import { FetchContext } from 'context/FetchContext';
import { useContext } from 'react';
import { useQuery } from 'react-query';

/**
 * Fetch rating stats: { average, total, distribution: { 1:n, 2:n, 3:n, 4:n, 5:n } }
 */
function useGetRatingStats(data = {}) {
  const { enabled = false } = data;
  const { privateFetch } = useContext(FetchContext);

  return useQuery(
    ['admin-rating-stats'],
    () => privateFetch.get('/v1/admin/podcast/user-ratings/stats').then((r) => r.data),
    { enabled, keepPreviousData: true }
  );
}

export default useGetRatingStats;
